"use client";

import {  useRouter } from "next/navigation";
import ContactUsForm from "@/components/ContactUsForm";
import React, {useEffect, useState} from "react";


export default function Home() {
    const router = useRouter()


  return (
    <main >
        <div>
            <section>
                <div className={"mx-auto p-5 lg:max-w-5xl"}>
                    <ContactUsForm/>
                </div>
            </section>
        </div>
    </main>
  );
}
